import React, { FC } from 'react'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'
import { businessSupportStrings } from 'common/strings/business-support-strings'
import imageResize from 'project/image-proxy-web'

type OurPartnersType = {
  className?: string
}

type LogoType = {
  imageSource: string
  imageAlt: string
  mobileWidth: number
}
const logos: [
  [
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
  ],
  [
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
    LogoType,
  ],
] = [
  [
    {
      imageAlt: 'Tide',
      imageSource: require('public/images/logos/tide-logo-blue-noreg.svg'),
      mobileWidth: 121,
    },
    {
      imageAlt: 'Crunch',
      imageSource: require('public/images/logos/crunch-logo-pink.svg'),
      mobileWidth: 139,
    },
    {
      imageAlt: 'Wise',
      imageSource: require('public/images/logos/wise_logo.svg'),
      mobileWidth: 143,
    },
    {
      imageAlt: 'Anna Money',
      imageSource: require('public/images/logos/ANNA_Money_Logo.png'),
      mobileWidth: 128,
    },
    {
      imageAlt: 'Anorak',
      imageSource: require('public/images/logos/anorak_logo.svg'),
      mobileWidth: 145,
    },
    {
      imageAlt: 'Google Workspace',
      imageSource: require('public/images/logos/google-workspace-logo.svg'),
      mobileWidth: 150.5,
    },
    {
      imageAlt: 'Crisp',
      imageSource: require('public/images/logos/crisp_logo.jpg'),
      mobileWidth: 140,
    },
    {
      imageAlt: 'Ember',
      imageSource: require('public/images/logos/ember_logo.jpg'),
      mobileWidth: 124,
    },
    {
      imageAlt: 'Notion app',
      imageSource: require('public/images/logos/Notion_app_logo.jpg'),
      mobileWidth: 88,
    },
    {
      imageAlt: 'Cashplus',
      imageSource: require('public/images/logos/cashplus_logo.jpg'),
      mobileWidth: 138.35,
    },
    {
      imageAlt: 'Linklaw',
      imageSource: require('public/images/logos/linklaw_logo.jpg'),
      mobileWidth: 139.6,
    },
    {
      imageAlt: 'The curtain',
      imageSource: require('public/images/logos/the_curtain_logo.jpg'),
      mobileWidth: 144.2,
    },
  ],
  [
    {
      imageAlt: 'UK trade',
      imageSource: require('public/images/logos/uk-trade-logo.svg'),
      mobileWidth: 143.5,
    },
    {
      imageAlt: 'Microsoft startup',
      imageSource: require('public/images/logos/microsoft_startup_logo.png'),
      mobileWidth: 151,
    },
    {
      imageAlt: 'Stripe',
      imageSource: require('public/images/logos/Stripe_Logo.svg'),
      mobileWidth: 128.5,
    },
    {
      imageAlt: 'Funding circle',
      imageSource: require('public/images/logos/funding_circle_logo.svg'),
      mobileWidth: 140,
    },
    {
      imageAlt: 'Seed legals',
      imageSource: require('public/images/logos/seed_legals_logo.svg'),
      mobileWidth: 133,
    },
    {
      imageAlt: 'Legal zoom',
      imageSource: require('public/images/logos/legal_zoom_logo.svg'),
      mobileWidth: 146.5,
    },
    {
      imageAlt: 'Counting up',
      imageSource: require('public/images/logos/counting_up_logo.svg'),
      mobileWidth: 145.6,
    },
    {
      imageAlt: 'Osome',
      imageSource: require('public/images/logos/osome_logo.svg'),
      mobileWidth: 126.5,
    },
    {
      imageAlt: 'Superscript',
      imageSource: require('public/images/logos/superscript_logo.svg'),
      mobileWidth: 126,
    },
    {
      imageAlt: 'London partners',
      imageSource: require('public/images/logos/london_partners_logo.jpg'),
      mobileWidth: 99,
    },
    {
      imageAlt: 'Homelify',
      imageSource: require('public/images/logos/homelify_logo.jpg'),
      mobileWidth: 152.6,
    },
  ],
]

const OurPartners: FC<OurPartnersType> = ({
  className = 'mt-xxl-50 mt-lg-21 mt-14 mb-xxxl-68 mb-lg-66 mb-56',
}) => {
  const size = useWindowSize()
  return (
    <div className={classNames('container text-center', className)}>
      <h2
        className={classNames(
          'text-bold mb-lg-3',
          size.isLgOrHigher ? 'fs-fluid-36-80 lh-105' : 'h3 px-6',
        )}
        dangerouslySetInnerHTML={{
          __html: businessSupportStrings.ourPartners,
        }}
      />
      <p
        className={'text-xxxl--large2 text-bold px-sm-0 px-6'}
        dangerouslySetInnerHTML={{
          __html: `${businessSupportStrings.ourPartnersSubtitle}`,
        }}
      />
      <div className={'row mt-lg-19 mt-12'}>
        {logos.map((item) => (
          <div className={'col-lg-6'}>
            <div className={'row px-lg-0 px-6'}>
              {item.map((v) => (
                <div
                  className={
                    'col-6 d-flex justify-content-center align-items-center'
                  }
                  style={{ height: size.isXlOrHigher ? '250px' : '125px' }}
                >
                  <img
                    loading='lazy'
                    className={'img-fluid d-block'}
                    src={imageResize(v.imageSource)}
                    alt={`${v.imageAlt} logo`}
                    style={{
                      width: size.isXlOrHigher ? '' : `${v.mobileWidth}px`,
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default OurPartners
